import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteCreditList', {
    sectionName: 'Credits applied',
    dateDueColumnName: 'Date',
    typeColumnName: 'Type',
    referenceColumnName: 'Reference',
    appliedToColumnName: 'Applied to',
    currencyColumnName: 'Currency',
    paymentAmountColumnName: 'Payment',
});
